var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceTvOutline3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5083 6.88561C10.3229 6.7744 10.0921 6.77149 9.90399 6.87799C9.71588 6.98449 9.59961 7.18395 9.59961 7.40011V12.6498C9.59961 12.866 9.71588 13.0654 9.90399 13.1719C10.0921 13.2784 10.3229 13.2755 10.5083 13.1643L14.883 10.5394C15.0638 10.431 15.1743 10.2357 15.1743 10.025C15.1743 9.81419 15.0638 9.61889 14.883 9.51045L10.5083 6.88561Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3C3.34315 3 2 4.34315 2 6V14C2 15.6569 3.34315 17 5 17H19C20.6569 17 22 15.6569 22 14V6C22 4.34315 20.6569 3 19 3H5ZM4 6C4 5.44772 4.44772 5 5 5H19C19.5523 5 20 5.44772 20 6V14C20 14.5523 19.5523 15 19 15H5C4.44772 15 4 14.5523 4 14V6Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 19C7.44772 19 7 19.4477 7 20C7 20.5523 7.44772 21 8 21H16C16.5523 21 17 20.5523 17 20C17 19.4477 16.5523 19 16 19H8Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceTvOutline3);
export default __webpack_public_path__ + "static/media/device-tv_outline (3).4a26e0c784c66f8ca7a05b326410f929.svg";
export { ForwardRef as ReactComponent };